import React from "react";
import { format } from "date-fns";
import { Trans, useTranslation } from "react-i18next";
import { Link, Grid2, useTheme, Typography } from "@mui/material";
import { useMandatorContext } from "@rentablo/theming";
import { TermsMainTitle, TermsText } from "./shared";

const NAMESPACE = "disclaimerPage";

interface Props {
  showTitle?: boolean;
  gridItemLg?: number;
}
export const Disclaimer = ({ showTitle = true, gridItemLg = 8 }: Props) => {
  const { t, i18n } = useTranslation("translation", { keyPrefix: NAMESPACE });
  const { t: tGlobal } = useTranslation();
  const theme = useTheme();
  const { isRentablo } = useMandatorContext();
  const mandatorShortName = isRentablo ? "Rentablo" : "Depotcheck";
  const companyName = isRentablo
    ? "Rentablo GmbH"
    : tGlobal("aboutCompany.company.name");
  const vars = {
    mandatorShortName,
    companyName,
    year: format(new Date(), "yyyy"),
  };

  return (
    <Grid2 container>
      <Grid2
        size={{
          xs: 12,
          lg: gridItemLg,
        }}
      >
        {showTitle && (
          <>
            <TermsMainTitle variant="h1">{t("header.title")}</TermsMainTitle>
            <Typography
              variant="h2"
              sx={{
                paddingTop: theme.spacing(30),
                paddingBottom: theme.spacing(8),
                [theme.breakpoints.down("md")]: {
                  paddingTop: theme.spacing(16),
                },
              }}
            >
              {t("header.subtitle")}
            </Typography>
          </>
        )}
        <TermsText variant="body3" color="textSecondary">
          {t("content.section1", vars)}
          <br />
          {t("content.section1Break")}
        </TermsText>
        <TermsText variant="body3" color="textSecondary">
          {t("content.section2")}
        </TermsText>

        <TermsText>{t("content.section3")}</TermsText>

        <TermsText variant="body3" color="textSecondary">
          {t("content.section4", vars)}
        </TermsText>
        <TermsText variant="body3" color="textSecondary">
          {t("content.section5", vars)}
        </TermsText>
        <TermsText variant="body3" color="textSecondary">
          {t("content.section6", vars)}
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          {t("content.section7")}
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          {t("content.section8", vars)}
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          <Trans
            i18nKey={`${NAMESPACE}.content.section9`}
            components={[
              <Link
                href="http://www.google.com/analytics/"
                target="_blank"
                rel="noreferrer"
                underline="hover"
              />,
            ]}
          />
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          {t("trademarks.section1")}
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          {t("trademarks.section2")}
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          {t("trademarks.section3")}
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          {t("trademarks.section4")}
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          {t("trademarks.section5")}
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          {t("trademarks.section6")}
        </TermsText>

        <TermsText variant="body3" color="textSecondary">
          <Trans
            i18nKey={`${NAMESPACE}.other.section1`}
            components={[
              <Link
                href="https://github.com/tresorone/tresor-import"
                target="_blank"
                rel="noreferrer"
                underline="hover"
              />,
            ]}
          />
        </TermsText>

        <Typography variant="body3" color="textSecondary">
          {t("other.section2")}
        </Typography>
        {showTitle && i18n.language === "en" && (
          <TermsText variant="body3" color="textSecondary" mt={10}>
            {tGlobal("common.englishLegalNote")}
          </TermsText>
        )}
      </Grid2>
    </Grid2>
  );
};
